import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=2766aaaa&scoped=true"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=2766aaaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766aaaa",
  null
  
)

export default component.exports